// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603051435/js/" + chunkId + "." + {"44":"6ec53012","225":"2c4e0acf","481":"6ba3e90a","486":"eca3e421","770":"3c440f12"}[chunkId] + ".0.5340867857003093.chunk.js";
};